import React from "react";
import { useSelector } from "react-redux";

import "./WithdrawnProjectsDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import WPDIcon from "assets/icons/withdrawn.svg";
import Construction from "assets/icons/construction-new.svg";
import Renovation from "assets/icons/renovation-new.svg";
import Support from "assets/icons/heart-new.svg";
import Transformation from "assets/icons/transformation-new.svg";
// import BudgetLargeIcon from "assets/icons/budget-large.svg";
import NoteSmallWhiteIcon from "assets/icons/notesmall-white.svg";
import NoteWhiteIconLight from "assets/icons/note-white-light.svg";
import TTCIcon from "assets/icons/ttc.svg";
import TTCIconLight from "assets/icons/ttc-light.svg";
import WDIcon from "assets/icons/withdrawn-new.svg";
import WalletBlue from "assets/icons/wallet-blue.svg";

const WithdrawnProjectsDashboard = () => {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);
  return (
    <>
       {/* Dropdowns Wrapper */}
     <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Timeoverrun Projects Pane */}
      <section className="withdrawn-projects-wrapper">
        <div className="withdrawn-projects-container">
          <div className="withdrawn-title">
            <img src={WPDIcon} alt="#" />
            <span>Withdrawn Projects</span>
          </div>
          <div className="withdrawn-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice And Right Section Slice Info */}
      <section className="withdrawn-project-region-wrapper">
        <div className="left-side-region">
          <div className="top">
            <div className="withdrawn-tile-projects-cover">
              <div className="icon-title">
                <div className="icon-cover">
                  <img src={WDIcon} alt="withdrawnicon" />
                </div>
                <div className="tile-name">
                  <span>Projects</span>
                </div>
              </div>
              <div className="sp-count">
                <span>90</span>
              </div>
            </div>
            <div className="withdrawn-tile-projects-cover">
              <div className="icon-title">
                <div className="icon-cover">
                  <img src={WalletBlue} alt="suspendedicon" />
                </div>
                <div className="tile-name">
                  <span>Budget</span>
                </div>
              </div>
              <div className="sp-count blue-count">
                <span>4.16bn</span>
                <span className="sp-currency">SAR</span>
              </div>
            </div>
          </div>
        </div>
        <div className="right-side-region">
          <div className="withdrawn-status-wrapper">
            <div className="withdrawn-status-container">
              <div className="header">
                <span>
                {selectedTheme === "dark" ? (
                <img src={NoteSmallWhiteIcon} alt="#" />
              ) : (
                <img src={NoteWhiteIconLight} alt="#" />
              )}
                  
                  Contract Status
                </span>
              </div>
              <div className="chart-container">
                <div className="chart-wrapper">
                  <div className="vertical-bar-container">
                    <div className="chart-system">
                      <span className="code">#</span>
                      <span className="currency">SAR</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>QASSAM</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "65%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>MAKKAH</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">81%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "81%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>RIYADH</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">32%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "32%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>MADINA</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">22%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "22%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>HAIL</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">36%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "36%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>NAJRAN</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">36%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "36%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>EASTERN</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">62%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "62%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>BAHA</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">54%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "54%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>AL-JOUF</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>ASIR</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>

                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>JAZAN</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="label">
                      <span>TABUK</span>
                    </div>
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "45%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value">272</span>
                      <span className="amount">14191.57M</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Progress Graph Section */}
      <section className="projects-progress-graph-wrapper">
        <div className="projects-progress-graph-container">
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info darkblue">
              <div className="head">
                <span>
                  <img src={Construction} alt="#" />
                  Construction Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalgreen"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalgreen">
              <div className="head">
                <span>
                  <img src={Renovation} alt="#" />
                  Renovation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white wastewater">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white wastewater">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalorange"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalorange">
              <div className="head">
                <span>
                  <img src={Transformation} alt="#" />
                  Transformation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white tse">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white tse">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalblue">
              <div className="head">
                <span>
                  <img src={Support} alt="#" />
                  Supportive Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Contractor / Withdrawn  Section */}
      <section className="withdrawn-contractor-projects-wrapper">
        <div className="withdrawn-contractor-projects-container">
          <div className="left">
            <div className="head">
              <span>
              {selectedTheme === 'dark'? <img src={TTCIcon} alt="#" />: <img src={TTCIconLight} alt="#" />}
                Top Withdrawn Contractors
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Contractors</th>
                      <th>Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>أن عدم تكاليف ارتكبها</td>
                      <td>1</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>أن عدم تكاليف ارتكبها</td>
                      <td>4</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>أن عدم تكاليف ارتكبها</td>
                      <td>19</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>أن عدم تكاليف ارتكبها</td>
                      <td>3</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>أن عدم تكاليف ارتكبها</td>
                      <td>7</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>أن عدم تكاليف ارتكبها</td>
                      <td>6</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
              {selectedTheme === 'dark'? <img src={TTCIcon} alt="#" />: <img src={TTCIconLight} alt="#" />}
                Withdrawn Projects / Regions
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Region</th>
                      <th>Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Northern</td>
                      <td>الضغوط والعتاد بقبل أن عدم تكاليف ارتكبها</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>الضغوط والعتاد بقبل أن عدم تكاليف ارتكبها</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>الضغوط والعتاد بقبل أن عدم تكاليف ارتكبها</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>الضغوط والعتاد بقبل أن عدم تكاليف ارتكبها</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>الضغوط والعتاد بقبل أن عدم تكاليف ارتكبها</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>الضغوط والعتاد بقبل أن عدم تكاليف ارتكبها</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="withdrawn-table-wrapper">
        <div className="withdrawn-table-container">
          <div className="container">
            <div className="head">
              <span>
              {selectedTheme === 'dark'? <img src={TTCIcon} alt="#" />: <img src={TTCIconLight} alt="#" />}
                Top Withdrawn Projects (Budget)
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Region</th>
                      <th># Of Projects</th>
                      <th>Budget SAR #</th>
                      <th>% Of Withdrawn</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Jazan</td>
                      <td>4</td>
                      <td>123,342,344</td>
                      <td>
                        <div className="withdrawn-budget-progress">
                          <div
                            className="percentage-progress-bar"
                            style={{ width: "50%" }}
                          ></div>
                          <span className="percent">50%</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Hail</td>
                      <td>3</td>
                      <td>123,342,344</td>
                      <td>
                        <div className="withdrawn-budget-progress">
                          <div
                            className="percentage-progress-bar"
                            style={{ width: "20%" }}
                          ></div>
                          <span className="percent">20%</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Tabuk</td>
                      <td>1</td>
                      <td>123,342,344</td>
                      <td>
                        <div className="withdrawn-budget-progress">
                          <div
                            className="percentage-progress-bar"
                            style={{ width: "60%" }}
                          ></div>
                          <span className="percent">60%</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Madina</td>
                      <td>1</td>
                      <td>123,342,344</td>
                      <td>
                        <div className="withdrawn-budget-progress">
                          <div
                            className="percentage-progress-bar"
                            style={{ width: "70%" }}
                          ></div>
                          <span className="percent">70%</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Riyadh</td>
                      <td>7</td>
                      <td>123,342,344</td>
                      <td>
                        <div className="withdrawn-budget-progress">
                          <div
                            className="percentage-progress-bar"
                            style={{ width: "90%" }}
                          ></div>
                          <span className="percent">90%</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WithdrawnProjectsDashboard;
